import { Avatar as MuiAvatar, ListItemAvatar } from '@mui/material';
import { AvatarProps } from 'types/common';

import { getInitials } from 'utils/helpers';

const Avatar = ({ name, url, avatarProps, ...props }: AvatarProps) => {
    return (
        <ListItemAvatar {...props}>
            {url && (url?.includes('http') || props?.file) ? (
                <MuiAvatar src={url} alt={name} {...avatarProps} />
            ) : name ? (
                <MuiAvatar {...avatarProps}>{getInitials(name)}</MuiAvatar>
            ) : (
                <MuiAvatar {...avatarProps} />
            )}
        </ListItemAvatar>
    );
};

export default Avatar;
